module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noResults":"No results","loading":"Loading..."},"de":{"noResults":"Keine Ergebnisse","loading":"Laden..."},"fr":{"noResults":"Aucun résultat","loading":"Chargement..."},"it":{"noResults":"Nessun Risultato","loading":"Caricare..."}}')
  delete Component.options._Ctor
}
